import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';

import { type OrderColumn, OrderColumns } from '@asset-solutions/customer-portal/orders/models';
import { deepCopy } from '@asset-solutions/shared/utilities';

@Component({
  selector: 'orders-column-picker',
  imports: [MatIcon, DragDropModule, MatCheckbox],
  templateUrl: './column-picker.component.html',
  styleUrls: ['./column-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnPickerComponent {
  @Input() set userColumns(userColumns: OrderColumn[]) {
    this._userColumns = deepCopy(userColumns);
    this.unselectedColumns = OrderColumns.filter(
      (column) => !this._userColumns.find((userColumn) => userColumn.key === column.key)
    );
  }
  get userColumns(): OrderColumn[] {
    return this._userColumns;
  }
  @Output() updateOrderColumns = new EventEmitter<OrderColumn[]>();

  public unselectedColumns: OrderColumn[] = [];
  private _userColumns: OrderColumn[] = [];

  public onColumnAdd(column: OrderColumn): void {
    this._userColumns.push(column);
    this.updateOrderColumns.emit(this.userColumns);
  }

  public onColumnRemove(column: OrderColumn): void {
    const index = this.userColumns.indexOf(column);
    this._userColumns.splice(index, 1);
    this.updateOrderColumns.emit(this.userColumns);
  }

  public updateColumnPrefs($event: CdkDragDrop<OrderColumn[]>): void {
    moveItemInArray(this._userColumns, $event.previousIndex, $event.currentIndex);
    this.updateOrderColumns.emit(this.userColumns);
  }
}
